import { useResourceValue } from '@composables'
import i18n from '@plugins/localisation.js'

export const schema = {
  config: [
    {
      label: 'version',
      key: 'version',
      type: 'string',
      cellClass: 'tw-text-left',
    },
    {
      label: 'release_notes',
      key: 'changelog',
      fallback: 'N/A',
      type: 'string',
      cellClass: 'tw-hidden lg:tw-table-cell tw-text-left',
    },
    {
      label: 'added',
      key: 'date_added',
      cellClass: 'tw-text-center',
      format: 'time',
      type: 'string',
      sort: {
        direction: 'desc',
      },
    },
    (item) => ({
      label: 'download',
      cellClass: 'tw-text-right',
      type: 'action',
      status: true,
      attrs: {
        icon: 'download',
        disabled: !item.downloadable,
      },
      tooltip: getTooltip(item),
      tooltipFixed: true,
      background: 'danger',
      sortable: false,
      onClick:
        item.authRequired || item.paidRequired ? 'handleAuthDownload' : null,
      to:
        item.authRequired || item.paidRequired
          ? null
          : (file) => file.download.binary_url,
    }),
  ],
  defaultSort: 'date_added',
}

function getTooltip(item) {
  const { ugcName } = useResourceValue()

  if (item.downloadable) return ''
  if (item.downloadInGame)
    return i18n.global.t('download_from_game_client', {
      mod: ugcName(null, true, true).value,
    })
  if (item.restrictDownloadNotPurchased)
    return i18n.global.t('download_payment_required', {
      ugc: ugcName(null, true, true).value,
    })
  if (item.restrictDownloadAuth)
    return i18n.global.t('download_auth_required', {
      ugc: ugcName(null, true, true).value,
    })
}
